import { render, staticRenderFns } from "./VideoCatePage.vue?vue&type=template&id=9bc6c348&scoped=true&"
import script from "./VideoCatePage.vue?vue&type=script&lang=js&"
export * from "./VideoCatePage.vue?vue&type=script&lang=js&"
import style0 from "./VideoCatePage.vue?vue&type=style&index=0&id=9bc6c348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc6c348",
  null
  
)

export default component.exports